<template>
    <div v-loading="form.busy">
        <div class="form-row">
            <div class="form-group col-xl-12 mb-1"><label class="mb-1" :for="'name' + _uid">Название</label><input type="text" class="form-control" :id="'name' + _uid" v-model="name" :class="{ 'is-invalid': form.errors.has('name') }"><has-error :form="form" field="name"/></div>
            <div class="form-group col-xl-12 mb-1"><label class="mb-1" :for="'genitive_case' + _uid">В родительном падеже</label><input type="text" class="form-control" :id="'genitive_case' + _uid" v-model="genitive_case" :class="{ 'is-invalid': form.errors.has('genitive_case') }"><has-error :form="form" field="genitive_case"/></div>
            <div class="form-group col-xl-12 mb-1"><label class="mb-1" :for="'dative_case' + _uid">В дательном падеже</label><input type="text" class="form-control" :id="'dative_case' + _uid" v-model="dative_case" :class="{ 'is-invalid': form.errors.has('dative_case') }"><has-error :form="form" field="dative_case"/></div>
            <div class="form-group col-xl-12 mb-1"><label class="mb-1" :for="'accusative_case' + _uid">В винительном падеже</label><input type="text" class="form-control" :id="'accusative_case' + _uid" v-model="accusative_case" :class="{ 'is-invalid': form.errors.has('accusative_case') }"><has-error :form="form" field="accusative_case"/></div>
            <div class="form-group col-xl-12 mb-1"><label class="mb-1" :for="'instrumental_case' + _uid">В творительном падеже</label><input type="text" class="form-control" :id="'instrumental_case' + _uid" v-model="instrumental_case" :class="{ 'is-invalid': form.errors.has('instrumental_case') }"><has-error :form="form" field="instrumental_case"/></div>
            <div class="form-group col-xl-12 mb-1"><label class="mb-1" :for="'prepositional_case' + _uid">В предложном падеже</label><input type="text" class="form-control" :id="'prepositional_case' + _uid" v-model="prepositional_case" :class="{ 'is-invalid': form.errors.has('prepositional_case') }"><has-error :form="form" field="prepositional_case"/></div>
<!--            <div class="form-group col-xl-12 mb-1"><label class="mb-1" :for="'basis' + _uid">Действующий на основании (пример: Устава, Доверенности)</label><input type="text" class="form-control" :id="'basis' + _uid" v-model="basis" :class="{ 'is-invalid': form.errors.has('basis') }"><has-error :form="form" field="basis"/></div>-->
            <div class="form-group col-xl-12 mb-1">
                <label class="mb-1" :for="'platform_id' + _uid">Площадка</label>
                <Select2 v-model="platform_id" :options="platform_select" :id="'platform_id' + _uid" :settings="{width: '100%'}"/>
                <has-error :form="form" field="platform_id" class="d-block"/>
            </div>
        </div>
        <div class="form-row mt-4">
            <div class="form-group col-12">
                <button v-if="mode === 'create'" class="btn btn-primary" @click="create">Создать</button>
                <button v-if="mode === 'edit'" class="btn btn-primary" @click="update">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "vform";

export default {
    name: "PositionForm",
    props: {
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return ['create', 'edit'].indexOf(value) !== -1
            }
        },
        obj: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data: () => ({
        name: null,
        genitive_case: null,
        dative_case: null,
        accusative_case: null,
        instrumental_case: null,
        prepositional_case: null,
        basis: null,
        platform_id: null,
        form: new Form({})
    }),
    computed: {
        platform_select() {
            let options = [];
            let user = this.$store.getters['auth/user'];
            if (user && user.allowed_platforms) {
                user.allowed_platforms.forEach(function (item) {
                    options.push({id: item.id, text: item.name})
                })
            }
            return options;
        },
    },
    mounted() {
        if (this.mode === 'create') {
            if (this.platform_select.length) this.platform_id = this.platform_select[0].id;
            if (this.obj) {
                this.name = this.obj.name;
                this.genitive_case = this.obj.genitive_case;
                this.dative_case = this.obj.dative_case;
                this.accusative_case = this.obj.accusative_case;
                this.instrumental_case = this.obj.instrumental_case;
                this.prepositional_case = this.obj.prepositional_case;
                this.basis = this.obj.basis;
                this.platform_id = this.obj.platform_id ? this.obj.platform_id : this.platform_id;
            }
        }
        if (this.mode === 'edit' && this.obj) {
            this.name = this.obj.name;
            this.genitive_case = this.obj.genitive_case;
            this.dative_case = this.obj.dative_case;
            this.accusative_case = this.obj.accusative_case;
            this.instrumental_case = this.obj.instrumental_case;
            this.prepositional_case = this.obj.prepositional_case;
            this.basis = this.obj.basis;
            this.platform_id = this.obj.platform_id;
        }
    },
    methods: {
        validate() {
            this.form = new Form({
                name: this.name,
                genitive_case: this.genitive_case,
                dative_case: this.dative_case,
                accusative_case: this.accusative_case,
                instrumental_case: this.instrumental_case,
                prepositional_case: this.prepositional_case,
                basis: this.basis,
                platform_id: this.platform_id,
            })
            return true;
        },
        create() {
            let self = this;
            this.validate();
            this.form.post('/api/positions')
                .then(response => {
                    self.$emit('created', response.data);
                })
        },
        update() {
            let self = this;
            this.validate();
            this.form.put('/api/positions/' + this.obj.id)
                .then(response => {
                    self.$emit('updated', response.data);
                })
        },

    }
}
</script>

<style scoped>

</style>
